import type {
  GlobalState, TabArgs,
  TabState,
} from '../types';

import { getCurrentTabId } from '../../util/establishMultitabRole';
import { INITIAL_TAB_STATE } from '../initialState';

export function selectTabState<T extends GlobalState>(
  global: T, ...[tabId = getCurrentTabId()]: TabArgs<T>
): TabState {
  return global.byTabId[tabId] || {
    ...INITIAL_TAB_STATE,
    id: tabId,
  };
}
